
import { useEffect } from 'react'
import Select from 'react-select'
import { EnergyStatusDDLAPI, UnitTypeDDLAPI, WTPBedNoDDLAPI, WTPFilterBatteryNoDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPBedNumberDDLData = (props) => {
    const { BedNo, setBedNo,FilterBatteryNo, rowData, Flag, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            M_WTP_FilterBatteryNoID:FilterBatteryNo.ID
        }
        dispatch(WTPBedNoDDLAPI({ data }))
    }, [IsPost,FilterBatteryNo.ID])

    const { WTPBedNoData } = useSelector(state => state.WTPBedNoDDLData)

    useEffect(() => {
        handleWTPBedNumberDDL()
    }, [WTPBedNoData])

    const handleWTPBedNumberDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPBedNoData && WTPBedNoData.table && WTPBedNoData.table.length > 0) {
            let list = WTPBedNoData.table.map((item, index) => ({
                value: item.m_wtP_BedMasterID,
                label: item.bedNumber,
            }))
            setBedNo({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_wtP_BedMasterID : 0,
                Label: Flag === 'Update' ? rowData.bedNumber : "Select...",
            })
        }
        else {
            setBedNo({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Bed Number </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: BedNo.ID, label: BedNo.Label }}
                onChange={(e) => {
                    e ?
                        setBedNo({ ...BedNo, ID: e.value, Label: e.label })
                        :
                        setBedNo({ ...BedNo, ID: 0, Label: "Select..." })

                }}
                options={BedNo.DDL}
            />
        </div>
    )
}